

export interface PriceInCurrency {
    currencyId: string;
    price: number;
}




export interface LocalizedString {
    [s: string]: string
}

export enum PaymentProviderType {
    cloudpayments = 'CloudPaymentsCheckout',
    sbpTochka = 'SBPTochka',
    offline = 'Offline',
    toBankCard = 'BankCardRequisites',
    companyInvoice = 'CompanyBankAccountRequisites',
    sberbank = 'SberbankCheckout'

}

export enum ServiceFeeType {
    fixed = 'Fixed',
}
